import type { ILogService } from "angular";
import { module } from "angular";
import type { Observable } from "rxjs";
import { from as observableFrom } from "rxjs";

import { cloneDeep } from "lodash";

import type { IModalService } from "App/Modules/Services";

export class ModalService implements IModalService {
    public static $inject = ["$log", "$uibModal", "$uibModalStack"];

    private onCloseAllSubscribers: Array<() => void> = [];

    constructor(
        private $log: ILogService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
    ) {}

    public open<TFormData, TBindings, TResult = TFormData>(
        componentName: string,
        formData: TFormData,
        bindings?: TBindings,
        size = "md",
        windowClass?: string,
    ): Observable<TResult> {
        const modalInstance = this.$uibModal.open({
            backdrop: "static",
            component: componentName,
            resolve: {
                bindings: () => bindings,
                formData: () => cloneDeep(formData),
                options: () => ({
                    onOk(result: TResult) {
                        modalInstance.close(result);
                    },
                    onCancel(reason?: any) {
                        modalInstance.dismiss(reason);
                    },
                }),
            },
            size,

            // eslint-disable-next-line prefer-template
            windowClass: (windowClass ? windowClass + " " : "") + "mm-modal",
        });
        return observableFrom(modalInstance.result as any as Promise<TResult>);
    }

    public closeAll() {
        this.$uibModalStack.dismissAll("Dismiss all open modals");

        this.onCloseAllSubscribers.forEach((cb) => cb());
    }

    public onCloseAll(callback: () => void) {
        this.onCloseAllSubscribers.push(callback);
    }
}

module("mmServices").service("mmModalService", ModalService);
